import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { IconButton, makeStyles } from '@material-ui/core';
import {
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
  IndeterminateCheckBox as IndeterminateCheckBoxIcon
} from '@material-ui/icons';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    color: props =>
      props.checked ? theme.palette.primary.main : theme.palette.text.secondary,
    margin: theme.spacing(0, 1, 0, 0)
  }
}));

const SelectAllButton = ({
  loading,
  hasPermission,
  totalMatchingTasksCount,
  assignedTasksCount,
  onClick
}) => {
  const { formatMessage } = useIntl();
  const classes = useStyles({ checked: assignedTasksCount !== 0 });

  const renderDisplayIcon = () => {
    if (loading) {
      return <CheckBoxOutlineBlankIcon />;
    }

    switch (assignedTasksCount) {
      case 0:
        return <CheckBoxOutlineBlankIcon data-qe-id="Checkbox_Unchecked" />;
      case totalMatchingTasksCount:
        return <CheckBoxIcon data-qe-id="Checkbox_Checked" />;
      default:
        return (
          <IndeterminateCheckBoxIcon data-qe-id="Checkbox_Indeterminate" />
        );
    }
  };

  const isSelectAllButtonDisabled =
    loading || !hasPermission || !totalMatchingTasksCount;
  const selectAllButtonRef = useRef(null);

  useEffect(() => {
    if (!isSelectAllButtonDisabled) {
      selectAllButtonRef?.current?.focus();
    }
  }, [isSelectAllButtonDisabled]);

  return (
    <IconButton
      disabled={isSelectAllButtonDisabled}
      className={classes.root}
      onClick={onClick}
      aria-label={formatMessage({ id: 'button.selectAll' })}
      ref={selectAllButtonRef}
      data-qe-id="SelectAllButton"
    >
      {renderDisplayIcon()}
    </IconButton>
  );
};

SelectAllButton.propTypes = {
  loading: PropTypes.bool,
  hasPermission: PropTypes.bool,
  totalMatchingTasksCount: PropTypes.number,
  assignedTasksCount: PropTypes.number,
  onClick: PropTypes.func
};

export default SelectAllButton;
